import authentication from "../authentication";
import fetchRefreshToken from "../fetches/fetchRefreshToken"
import dayjs from "../libs/dayjs";
import axios from "../libs/axios";

export default async (req: any) => {
  // 토큰이 있다면..
  const certificate = authentication.get();
  const left = dayjs(certificate.accessTokenExpiresAt).diff(+new Date(), 's');

  if (
    //* 토큰이 유효하고,
    certificate.accessToken &&
    //* 남은 시간이 1초 이상이고,
    left > 0 &&
    //* 업데이트 한지 2초 이상이면,
    dayjs().diff(certificate.updateAt, 's') > 1
  ) {
    //* 토큰 갱신 시도 (실패해도 원래 요청은 계속 진행)
    try {
      const res = await fetchRefreshToken();
      authentication.set(res.data);
    } catch (e:any) {
      console.warn('Token refresh failed, continuing with original request:', e?.response?.status);
      // 토큰 갱신 실패 시에도 원래 API 요청은 계속 진행
      // 실제 API 요청에서 401이 발생하면 그때 처리
    }
  }

  return req.responseType === 'blob'
    ? axios(req)
    : axios(req).then((res) => res.data);
};
